"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const use_theme_1 = __importDefault(require("../hooks/use-theme"));
const tailwind_1 = __importDefault(require("../utils/tailwind"));
const styles = (0, tailwind_1.default)({
    // see styles.css
    svg: `
    react-celo-spinner`,
    circle: `
    react-celo-spinner-path
    tw-stroke-current`,
});
function Spinner({ className = '', style = {} }) {
    const theme = (0, use_theme_1.default)();
    return (react_1.default.createElement("svg", { className: `${styles.svg} ${className}`, style: Object.assign({ color: theme.primary }, style), viewBox: "0 0 50 50" },
        react_1.default.createElement("circle", { className: styles.circle, cx: 25, cy: 25, r: 20, strokeWidth: "5", fill: "none" })));
}
exports.default = Spinner;
//# sourceMappingURL=spinner.js.map